import React from 'react'

import Layout from '../components/Layout'
import RequestPasswordResetForm from '@/features/auth/components/RequestPasswordResetForm'

const RequestPasswordResetPage = () => {
  return (
    <Layout title="Can't Login ? - Login with E Approval account">
      <RequestPasswordResetForm />
    </Layout>
  )
}

export default RequestPasswordResetPage
